import type { IconProps } from "@/types/IconProps";

export function StarCircle(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      className={className}
      viewBox="0 0 28 28"
      {...svgProps}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14m-5.29-6.344L14 18.695l5.29 2.961-1.181-5.946 4.45-4.116-6.02-.714L14 5.375l-2.539 5.505-6.02.714 4.45 4.116z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
